import { cache } from "../persistence/cache";
import defaults from '../../constants'



/**
 * @module web/store
 * @private
 */

const PROFILE_TYPE = 'EV';
let profileType = null;

/**
 * Update the user profileType related data, by storing it in memory.
 * @param {Object} newProfileType - An object containing user profileType data obtained from a request through a backend call.
 * @public
 */
const update = function (newProfileType) {
    profileType = newProfileType;
};

/**
 * Returns the current user profileType related data object stored in memory, where it will be searched for.
 * @returns {Object} - A found stored profileType related data object or null if not found in memory.
 * @public
 */
const get = async function (self) {

    const _this = self

    let cachedUser = null;

    // for logged in 
    if (_this.localCache && _this.localCache.auth) {
        cachedUser = await cache.get("user", { database: "auth" });
    }
    if (cachedUser && cachedUser.profileType) {
        profileType = cachedUser.profileType;
    }

    // for guest, in case auth db in not used like web client
    if(!profileType){
        const guestProfie = _this.guestProfie()
        profileType = guestProfie?.profileType || PROFILE_TYPE

    }
    return profileType;
};


export default { update, get };

